// src/store/modules/client.js
import apiService from '@/services/api.service';

const state = {
  clientInfo: {
    clientId: null,
    devices: [],
    events: []
  },
  loading: false,
  error: null
};

const getters = {
  clientInfo: state => state.clientInfo,
  devices: state => state.clientInfo.devices,
  events: state => state.clientInfo.events,
  loading: state => state.loading,
  error: state => state.error
};

const actions = {
  async fetchDashboard({ commit }) {
    commit('setLoading', true);
    commit('clearError');
    try {
      const response = await apiService.getClientDashboard();
      commit('setClientInfo', response.data);
      return response.data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Erreur de chargement');
      throw error;
    } finally {
      commit('setLoading', false);
    }
  }
};

const mutations = {
  setClientInfo(state, clientInfo) {
    state.clientInfo = clientInfo;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setError(state, error) {
    state.error = error;
  },
  clearError(state) {
    state.error = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
